export default __webpack_public_path__ + "static/media/qt.083c61c0.svg";